<template>
    <v-combobox-filled
        label="Pays"
        :items="countries"
        item-value="value"
        v-model="selectedCountry"
        outlined
        dense
        hide-details
        item-title="text"
    >
    </v-combobox-filled>
</template>

<script lang="ts">
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Model } from "vue-facing-decorator";

type CountryType = {
    value: string;
    text: string;
};

@Component
export class OssCountrySelector extends Vue {
    @Model({ default: null }) value!: string | null;

    get selectedCountry(): CountryType | null {
        return this.countries.find((country) => country.value === this.value);
    }

    set selectedCountry(value: CountryType) {
        this.value = value.value;
    }

    get countries(): CountryType[] {
        return require("../taxForm/selectors/2023/PAY.json").values;
    }
}

export default toNative(OssCountrySelector);
</script>

<style></style>
